// Forme par défaut d'un album, partagée entre l'ajout groupé et le scan en rafale.
export const emptyBD = (overrides) => ({
  serie:'',numero:'',titre:'',auteur:'',dessinateur:'',coloriste:'',scenariste:'',
  editeur:'',collection:'',dateParution:'',isbn:'',format:'',langue:'Français',
  genre:'',nbPages:'',etatGeneral:'bon',defauts:[],statut:'garder',note:0,
  prixAchat:'',prixVente:'',lieu:'',emplacement:'',
  lu:false,dedicace:false,eo:false,numerote:false,
  dateAchat:'',lieuAchat:'',dateLecture:'',
  notes:'',
  ...overrides,
});
